<template src="./index.html"></template>
<style src="./style.scss" lang="scss" scoped></style>
<script>
import { mapGetters } from 'vuex';

import Navbar from '@/components/Navbar';
import ProgressBar from '@/components/ProgressBar';
import BackButton from '@/components/BackButton';
import CustomButton from '@/components/CustomButton';
import Background from '@/components/Background';
import TextFlowNumber from '@/components/TextFlowNumber';
import CallFlowDropdown from '@/components/CallFlowDropdown';
import { ROUTE_TYPES } from '@/constants';
import { M_SET_TEXT_FLOW_TO_GROUP, M_ONBOARDING_STEP } from '@/graphql';

export default {
  name: 'TextRouteGroup',
  components: {
    Navbar,
    ProgressBar,
    BackButton,
    CustomButton,
    Background,
    TextFlowNumber,
    CallFlowDropdown
  },
  data() {
    return {
      isLoading: false,
      selectedGroup: null
    };
  },
  computed: {
    ...mapGetters({
      user: 'auth/getUser',
      groups: 'auth/getUserGroups',
      phoneName: 'onboarding/getSelectedName',
      phoneNumber: 'onboarding/getSelectedNumber',
      phoneId: 'onboarding/getSelectedId',
      textFlow: 'onboarding/getSelectedTextFlow'
    })
  },
  mounted() {
    if (this.textFlow && this.textFlow.type === ROUTE_TYPES.ROUTE_GROUP) {
      this.selectedGroup = this.groups.find((group) => group.id === this.textFlow.toGroup.id);
    }
  },
  methods: {
    onSelect(item) {
      return (this.selectedGroup = item);
    },
    /**
     * "Next" button click
     * @returns {Promise<void>}
     */
    async onNext() {
      try {
        await this.$store.dispatch('onboarding/setTextFlow', {
          type: ROUTE_TYPES.ROUTE_GROUP,
          toGroup: this.selectedGroup
        });

        // send mutation request if different user is selected
        await this.$apollo.mutate({
          mutation: M_SET_TEXT_FLOW_TO_GROUP,
          variables: {
            phoneNumberId: this.phoneId,
            groupId: this.selectedGroup.id
          }
        });

        await this.$apollo.mutate({
          mutation: M_ONBOARDING_STEP,
          variables: {
            user_id: this.user.id,
            onboarding_step: 5
          }
        });
        await this.$store.dispatch('onboarding/setOnboardingStep', 5);
        // enable the Next button
        this.isLoading = false;

        console.log('SMS ROUTING -> GROUPS: NEXT');
        this.$router.push('/onboarding-mobile');
      } catch (error) {
        this.isLoading = false;
        return console.log('SMS ROUTING -> GROUPS: ERROR\n', error);
      }
    }
  }
};
</script>
